<template>
  <sn-modal
    v-model="value"
    title="Help & support"
    data-cy="help-and-support-modal"
    type="dismiss"
    @input="$emit('close')"
  >
    <v-col cols="12">
      <span
        class="sn-subtitle-1"
        data-cy="support-subtitle"
      >
        Find answers to your questions:
      </span>
      <br>
      <sn-btn
        class="mt-4 mb-8"
        data-cy="ask-nexus"
        type="text"
        text-case=""
        text-size="sn-body-2"
        :icon-size="24"
        prepend-icon="$snEarth"
        href="https://www.asknexus.com/help/settlement-agents"
        text="https://www.asknexus.com/help/settlement-agents"
      />
      <br>
      <v-divider class="mb-2" />
      <br>
      <span
        class="sn-subtitle-1"
        data-cy="support-subtitle-2"
      >
        We're here to help Monday-Friday, 7am - 6pm MT.
      </span>
      <br>
      <sn-btn
        class="mt-5"
        data-cy="support-phone"
        type="text"
        text-case=""
        text-size="sn-body-2"
        :icon-size="24"
        prepend-icon="$snPhone"
        href="tel:+1-855-684-2715"
        text="855-684-2715"
      />
      <br>
      <sn-btn
        class="mt-5 mb-4"
        data-cy="support-email"
        type="text"
        text-case=""
        text-size="sn-body-2"
        :icon-size="24"
        prepend-icon="$snMail"
        href="mailto:eclosesupport@simplenexus.com"
        text="eclosesupport@simplenexus.com"
      />
    </v-col>
  </sn-modal>
</template>

<script>

export default {
  name: 'RecipientHelpAndSupport',

  props: {
    value: {
      type: Boolean,
      default: false,
      required: true
    }
  },

  data () {
    return {
      dialog: this.value
    }
  },

  watch: {
    dialog (value, oldValue) {
      if (value !== oldValue) {
        this.$emit('input', value)
      }
    },
    value (val) {
      this.dialog = val
    }
  }
}
</script>
